import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogProps, Paragraph } from '@expressable/syntax-ds';

type Props = DialogProps & { onConfirm: () => void };

export const DirectSignupAddSecondaryInsuranceDialog = ({ onConfirm, ...dialogProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      <Dialog.Header>
        <Dialog.Title>{t('directSignup.dialogs.addSecondaryInsurance.title')}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Paragraph>{t('directSignup.dialogs.addSecondaryInsurance.body')}</Paragraph>
      </Dialog.Body>

      <Dialog.CTAs>
        <Button onClick={onConfirm}>{t('directSignup.dialogs.addSecondaryInsurance.confirm')}</Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
